import { createConsultationModal } from "@/components/ConsultationModal";

export const { ConsultationModalProvider, useConsultationModal } =
  createConsultationModal();
